module.exports = __webpack_public_path__ + "img/pawprint.c3793757.svg";